import { Card, Grid, styled, withStyles } from '@material-ui/core';
import { theme } from '../theme/mui-theme';

export const StyledCard = withStyles({
  root: {
    display: 'grid',
    gridTemplateColumns: '4px 1fr',
  }
})(Card);

export const Edge = styled('div')({
  backgroundColor: theme.palette.primary.main
});

export const Content = styled(Grid)({
  padding: theme.spacing(2)
});

export const ReservationDetailsGrid = styled(Grid)({
  textAlign: 'right',

  [theme.breakpoints.down('xs')]: {
    textAlign: 'left'
  }
});

export const NotesContainerGrid = styled(Grid)({
  display: 'flex',
  flexDirection: 'column',
  rowGap: theme.spacing(1),
  flexGrow: 1
});
